<ng-container>
  <div class="news-categories-wrapper">
    <div class="section-name">{{ 'newsArticles.newsTitle' | cxTranslate }}</div>
    <ul [ngClass]="activeLanguage$ | async">
      <li (click)="selectCategory('ALL')" [ngClass]="{ active: activeNewsCategoryCode === 'ALL' }">
        {{ 'newsArticles.all' | cxTranslate }}
      </li>
      @if (newsCategory$ | async; as data) { @for (category of data.categories; track category) {
      <li
        [ngClass]="{ active: activeNewsCategoryCode === category.code }"
        (click)="selectCategory(category.code, category.name)"
      >
        {{ category.name }}
      </li>
      } }
    </ul>

    <div class="btn-group">
      <div mat-button [matMenuTriggerFor]="categoryMenu">
        <span class="label-wrapper">
          {{ activeNewsCategoryCode !== 'ALL' ? activeNewsCategoryName : ('newsArticles.all' | cxTranslate) }}
          <mat-icon class="expand-icon">expand_more</mat-icon>
        </span>
      </div>
      <mat-menu #categoryMenu="matMenu" class="custom-menu">
        <div
          mat-menu-item
          (click)="selectCategory('ALL')"
          [ngClass]="{ 'selected-item': activeNewsCategoryCode === 'ALL' }"
        >
          @if (activeNewsCategoryCode === 'ALL') {
          <mat-icon svgIcon="check" class="check-icon"></mat-icon>
          }
          <span class="category-label">{{ 'newsArticles.all' | cxTranslate }}</span>
        </div>
        @if (newsCategory$ | async; as data) { @for (category of data.categories; track category) {
        <div
          mat-menu-item
          (click)="selectCategory(category.code, category.name)"
          [ngClass]="{ 'selected-item': activeNewsCategoryCode === category.code }"
        >
          @if (activeNewsCategoryCode === category.code) {
          <mat-icon svgIcon="check" class="check-icon"></mat-icon>
          }
          <span class="category-label">{{ category.name }}</span>
        </div>
        } }
      </mat-menu>
    </div>
  </div>
</ng-container>
